"use strict";
// Helpers for the multi-email account model (BackofficeUser.emails).
// Emails are stored lowercased and trimmed so lookups are case-insensitive.
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeEmail = normalizeEmail;
function normalizeEmail(email) {
    return (email ?? '').trim().toLowerCase();
}
